// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__7Mecl","select":"Header_select__1BqCI","clinic":"Header_clinic__3k2Ou"};